
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/calixa",
      function () {
        return require("private-next-pages/destinations/calixa.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/calixa"])
      });
    }
  